// extracted by mini-css-extract-plugin
module.exports = {"ticketListItem":"TicketListItem_ticketListItem__1DF3p","avatar":"TicketListItem_avatar__2vHO0","location":"TicketListItem_location__1zdB7","right":"TicketListItem_right__2MmD4"};